import defaultImage from "../../../../assets/cities/delhi.png";

export const defaultActivity = {
  title: "Jai Hind Sound & Light Show at the Red Fort in Delhi",
  rating: 4.9,
  reviews: 1526,
  location: "New Delhi",
  image: defaultImage,
  gallery: [defaultImage, defaultImage, defaultImage, defaultImage],
  price: 500,
  date: "2026-06-19",
  time: "06:30 PM",
  travelers: 1,
};

export const packageOptions = [
  {
    id: "cat-cdefg",
    title: "Jai Hind Show : Category C,D,E,F,G",
    price: 500,
    details: [
      "1st Show: 6:30 PM in Hindi",
      "2nd Show: 7:45 PM English (Tuesday-Wednesday-Thursday) & Hindi (Friday-Saturday-Sunday)",
    ],
  },
  {
    id: "cat-b",
    title: "Jai Hind Show : Category B",
    price: 1000,
    details: [
      "1st Show: 6:30 PM in Hindi",
      "2nd Show: 7:45 PM English (Tuesday-Wednesday-Thursday) & Hindi (Friday-Saturday-Sunday)",
    ],
  },
  {
    id: "cat-a",
    title: "Jai Hind Show : Category A",
    price: 1500,
    details: [
      "1st Show: 6:30 PM in Hindi",
      "2nd Show: 7:45 PM English (Tuesday-Wednesday-Thursday) & Hindi (Friday-Saturday-Sunday)",
    ],
  },
];

export function formatActivityCurrency(value) {
  return `₹${Number(value || 0).toLocaleString("en-IN")}`;
}

export function formatActivityDate(date) {
  if (!date) return "19/06/2026";
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return date;
  return parsed.toLocaleDateString("en-GB");
}

export function buildActivityFromState(stateActivity) {
  if (!stateActivity) return defaultActivity;
  return {
    ...defaultActivity,
    ...stateActivity,
    location: stateActivity.location || stateActivity.city || defaultActivity.location,
    image: stateActivity.image || stateActivity.imageUrl || defaultActivity.image,
    gallery: [stateActivity.image || stateActivity.imageUrl || defaultActivity.image, ...defaultActivity.gallery].slice(0, 4),
    price: Number(stateActivity.price || defaultActivity.price),
    travelers: Number(stateActivity.travelers || defaultActivity.travelers),
  };
}

export function getTotalAmount(option, travelers) {
  return Number(option?.price || 0) * Number(travelers || 1);
}
